import { EmergencyFundPlanStep } from './EmergencyFundPlanStep';

export function PlanSimulator() {
  return (
    <div className="mx-auto flex w-full max-w-md flex-col gap-2 px-1 pb-8">
      <EmergencyFundPlanStep />
    </div>
  );
}

export default PlanSimulator;
